import { Button, Modal, Result, Spin, Statistic } from 'antd'
import { ModalProps } from 'antd/es/modal'
import React, { ReactNode, useEffect, useRef, useState } from 'react'
// import ReactDOM from 'react-dom';
import ReactDOM from 'react-dom/client'
import closeSvg from '@/assets/icon/close.svg'
import moment from 'moment'
import LeftPart from './components/leftPart/index'
import PayContent from './components/payContent/index'
import styles from './index.less'
import { couponIssue, couponIssueList, getActivity, getGoodList, getUserInfo } from './api'
import { desensitizationNumber } from '../../utils/util'
import RprmUtils from '@/utils/dot'
import { setUserInfo, useStore } from '@/states/store'
import { openBindTel } from '../BindTel/openBindTel'
import _, { add, get } from 'lodash'
import { use } from 'video.js/dist/types/tech/middleware'
import { addCookie, addFixedTimeCookie, getCookie } from '@/utils/cookie'
import { openCouponDialog } from './components/CouponDialog'
import dayjs from 'dayjs'
import classNames from 'classnames'

const { Countdown } = Statistic

interface IPayModalProps {
  // detailSource: number;
  type?: number //tab类型 1套餐 2加油包
  onSuccess?: Function // 支付成功回调
  pageInfo?: string //访问路径
  needBindTel?:boolean,
  showPrompt?: boolean, // 微力不足-显示提示文案
}

const bg1 = 'https://cdn2.weimob.com/saas/saas-fe-sirius-orion-node/production/zh-CN/483/dengluyebeijingtu.png'
const bg2 = 'https://cdn2.weimob.com/saas/saas-fe-sirius-orion-node/production/zh-CN/483/bg_guangxiaobeijing@2x.png'

const PayDialog = ({ onCancel,needBindTel=true, type = 1, pageInfo = undefined, onSuccess, ...rest }: IPayModalProps & ModalProps) => {
  const { userInfo } = useStore();  
  const [goodsList, setGoodsList] = useState<any>([])
  const [currentTab, setCurrentTab] = useState(userInfo?.oemFlag === 1 ? 2 : type)
  const [payUserInfo, setPayUserInfo] = useState<any>({})
  const [payStatus, setPayStatus] = useState<any>({
    member: 0,
    bag: 0,
  }) //0-未支付，1-已支付，2-支付失败 3-已失效  const bg1 = 'https://cdn2.weimob.com/saas/saas-fe-sirius-orion-node/production/zh-CN/483/bg_huangguanbeijing.png'
  const bg2 = 'https://cdn2.weimob.com/saas/saas-fe-sirius-orion-node/production/zh-CN/483/bg_guangxiaobeijing@2x.png'
  const [curDeadLineTime, setCurDeadLineTime] = useState(new Date().setHours(23, 59, 59, 999))
  const [couponList,setCouponList]=useState<any>([{
    id:0,//优惠券id,
    couponType:'coupon', //'coupon'||'retrieve_coupon',
    amount:50,
    effecitveCondition:50,
  }])
  const isOpenCoupon=getCookie('open_coupon') //是否弹过优惠券弹窗
  const isOpenRetrieve=getCookie('open_retrieve')//是否弹过挽留弹窗
  const goodListRef=useRef<any>(null)
  const couponListRef=useRef<any>(null)
  const firstCoupon=useRef<any>(false)
  const activityListRef=useRef<any>(null)
  const needScroll =useRef(false)
  const isOemSaas=userInfo?.oemFlag===1 && !userInfo?.loginSource
  
  useEffect(() => {
    getUser()
  }, [])
  useEffect(() => {
    getGoodsList()
  }, [currentTab])

  useEffect(() => {
    if (currentTab === 1) {
      RprmUtils.rec(`show_pay_tab`, 'view', { en: 'tap' })
    } else {
      RprmUtils.rec(`show_recharge_pay_tab`, 'view', { en: 'tap' })
    }
  }, [currentTab])


  // useEffect(() => {
  //   getCouponInfo()
  // }, [])
  const calculateInCents=(yuan1:number, yuan2:number,type='minus')=> {
    const cents1 = Math.round(yuan1 * 100);
    const cents2 = Math.round(yuan2 * 100);
    return type==='minus'?(cents1 - cents2) / 100:(cents1 + cents2) / 100;
}


  const calGoodsList=(validCoupon:any)=>{
    // console.log('validCoupon',validCoupon)
    const tem=_.cloneDeep(goodListRef.current)
    tem?.forEach((item:any)=>{
      validCoupon?.forEach((coupon:any)=>{
        if(item.orShowAmount>=Number(coupon.effecitveCondition)&&item.showAmount>=Number(coupon.amount)&&(!item.couponId ||item.couponId?.indexOf(coupon.id)===-1)){
          item.showAmount=calculateInCents(item.showAmount,coupon.amount)
          item.couponAmount=calculateInCents(item.couponAmount||0,coupon.amount,'plus')
          item.couponType=item.couponType?item.couponType.concat(coupon.couponType):[coupon.couponType]
          item.couponId=item.couponId?item.couponId.concat(coupon.id):[coupon.id]
        }
      })
    })
    goodListRef.current=tem
    setGoodsList(tem)
  }

  const getCouponInfo = async () => {
    try{
      const {data:activityInfo}:any=await getActivity()
      activityListRef.current=activityInfo
      if(!activityInfo||activityInfo?.length===0){
        return
      }
  
      const couponActivity=_.find(activityInfo,x=>x.couponType==='coupon')
      if(!!couponActivity){
        //还有正常优惠券活动
        const {data:couponObj}:any=await couponIssue({couponType:'coupon'})
        if(couponObj){
          //证明有优惠券
          if(!couponObj?.isHistory&&couponObj?.status===1){  
            //需要打开优惠券弹窗
            needScroll.current=true
            const imageUrl=JSON.parse(couponActivity.other)?.url
            openCouponDialog({
              imageUrl:imageUrl||'https://cdn2.weimob.com/saas/saas-fe-sirius-orion-node/production/zh-CN/483/bg_xianshihongbao.png',
              onClose:()=>{
                //发券券id要存下来吧？
                if(!couponListRef.current?.find((x: any)=>x.id===couponObj.id)){
                  couponListRef.current=couponListRef.current?couponListRef.current.concat(couponObj):[couponObj]
                }
                calGoodsList(couponListRef.current)
              }
            })
          }
        }
      }
    }catch(e){
      console.log('getCouponInfo===>error',e)
    }
  }

  const getUser = async (cb?: any) => {
    // const userId = getCookie('userId');
    getUserInfo({})
      .then((res: any) => {
        const { data } = res || {}
        setPayUserInfo({ ...data })
        cb && cb({ ...data })
      })
      .catch(err => {})
  }
  const getGoodsList = () => {
    const scrollFlag=needScroll.current

    getGoodList({ goodsType: currentTab, pageInfo: pageInfo })
      .then((res: any) => {
        const { data } = res || {}
        data.forEach((item:any)=>{
          item.orShowAmount=item.showAmount
        })
        if(scrollFlag){
         setGoodsList(data)
        }
        goodListRef.current=data
        if(!couponListRef.current){
          getValidCoupon()
          if(!firstCoupon.current){
            firstCoupon.current=true
            getCouponInfo()
          }
        }else{
          if(!scrollFlag){
            calGoodsList(couponListRef.current)
          }else{
            needScroll.current=false
            setTimeout(()=>{
              calGoodsList(couponListRef.current)
            },0)
          }
        }


      })
      .catch(err => {})
  }

  const getValidCoupon=async()=>{
          //获取券列表
          const {data:couponList}:any=await couponIssueList()
          const validCoupon=_.filter(couponList,x=>x.status===1)
          couponListRef.current=[]
          if(validCoupon.length>0){
            //有生效中的历史优惠券，直接减钱
            couponListRef.current=validCoupon
            //计算商品列表
            calGoodsList(validCoupon)
          }else{
            calGoodsList([])
          }
  }
  const closeBack=async()=>{
    try{
      if(!activityListRef.current||activityListRef.current.length===0){
        return false
      }
      if(couponListRef?.current&&couponListRef?.current?.find((x: any)=>x?.couponType==='retrieve_coupon'&&x?.status===1)){
        //有优惠券
        return false
      }
      const retrieve_coupon_activity=_.find(activityListRef.current,x=>x.couponType==='retrieve_coupon')
      if(retrieve_coupon_activity){
        //有挽回券活动
        const {data:retrieveCouponObj}:any=await couponIssue({couponType:'retrieve_coupon'})
        if(retrieveCouponObj&&!retrieveCouponObj.isHistory&&retrieveCouponObj?.status===1){
          //发挽回券成功，且不是历史
          needScroll.current=true
          const curActivity=_.find(activityListRef.current,x=>x.id===retrieveCouponObj.activityId)
          if(!curActivity) return
          const imageUrl=JSON.parse(curActivity.other)?.url
          openCouponDialog({
            imageUrl:imageUrl||'https://cdn2.weimob.com/saas/saas-fe-sirius-orion-node/production/zh-CN/483/bg_xianshihongbao.png',
            onClose:()=>{
              //发券券id要存下来吧？
              if(!couponListRef.current?.find((x: any)=>x.id===retrieveCouponObj.id)){
                couponListRef.current=couponListRef.current?couponListRef.current.concat(retrieveCouponObj):[retrieveCouponObj]
              }
              calGoodsList(couponListRef.current)
            }
          })
          return true
        }
      }
      return false
    }catch(e){
      console.log('closeBack===>error',e)
    }


  }

  const closeDialog = async (e: any) => {
    const isPaySuccess = payStatus['member'] === 1 || payStatus['bag'] === 1
    if (isPaySuccess) {
      setUserInfo(payUserInfo)
      if(!payUserInfo.isBindMobile&&needBindTel&&!isOemSaas){
        openBindTel({
          close:false
        })
      }else{
        if (location.href.indexOf('/personal-center') !== -1) {
          location.reload()
        }
      }
    }else{
      const backFlag=await closeBack()
      if(backFlag){
        return
      }

    }
    if (isPaySuccess) {
      onSuccess && onSuccess(payUserInfo)
    }
    onCancel && onCancel(payUserInfo)
  }

  useEffect(() => {
    RprmUtils.rec(`show_pay_dialog`, 'view', { en: 'tap', et: 'custom' })
  }, [])

  const getCouponStatus=()=>{
    // console.log('goodsList',goodsList)
    let flag=false
    goodsList.forEach((item:any)=>{
      if(item.couponId){
        flag=true
      }
    })
    return flag

  }

  return (
    <Modal open className={styles.payModal} centered width={932} footer={null} closable={false} {...rest} wrapClassName={styles.maskWrapper}>
      <div className={styles.close} onClick={closeDialog}>
        <img src={closeSvg} />
      </div>
      <div className={`${styles.payContainer} ${userInfo?.oemFlag === 1 && styles.payContainerOem}`}>
        {
          userInfo?.oemFlag !== 1 ? <div className={styles.topcontainer}>
            <div className={styles.header}>
              <img src={payUserInfo?.avatarUrl} alt="" />
              <div>
                <p className={styles.name}>{payUserInfo?.nickname || payUserInfo?.userId}</p>
                {payUserInfo?.mobileNo && <p className={styles.phone}>{`已绑定手机号：${desensitizationNumber(payUserInfo?.mobileNo)}`}</p>}
              </div>
            </div>
          </div> : null
        }
        <div className={styles.rightContainer}>
          <div className={styles.payContent}>
            {
              userInfo?.oemFlag !== 1 ? <div className={classNames(`${currentTab === 1 ? styles.payTab : styles.rechargePayTab}`,getCouponStatus()&&styles.couponStatus)}>
                <div
                  className={styles.memberTab}
                  onClick={() => {
                    setCurrentTab(1)
                  }}
                >
                  <div className={styles.memberTitle}>
                    会员套餐
                    
                    {currentTab === 1 && getCouponStatus()&&(
                      <div className={styles.rechargeCutDown}>
                        优惠券将于
                        <Countdown
                          title={null}
                          value={curDeadLineTime}
                          format="HH:mm:ss:SSS"
                          onFinish={() => {
                            console.log('onFinishonFinishonFinish', new Date().getTime())
                            setTimeout(() => {
                              setCurDeadLineTime(new Date().setHours(23, 59, 59, 999))
                            }, 100)
                            // setCutdownShow(false)
                          }}
                        />
                        后失效
                      </div>
                    )}                    </div>
                </div>
                <div
                  className={styles.rechargeTab}
                  onClick={() => {
                    setCurrentTab(2)
                  }}
                >
                  <div className={styles.memberTitle}>
                    加油包
                    {currentTab === 2 && (
                      <div className={styles.rechargeCutDown}>
                        {getCouponStatus()?'优惠券将于':''}
                        <Countdown
                          title={null}
                          value={curDeadLineTime}
                          format="HH:mm:ss:SSS"
                          onFinish={() => {
                            console.log('onFinishonFinishonFinish', new Date().getTime())
                            setTimeout(() => {
                              setCurDeadLineTime(new Date().setHours(23, 59, 59, 999))
                            }, 100)
                            // setCutdownShow(false)
                          }}
                        />
                        {getCouponStatus()?'后失效':'后结束'}
                      </div>
                    )}
                    {currentTab === 1 && <div className={styles.tip}>限时加赠</div>}
                  </div>
                </div>
              </div> : <div className={styles.rechargeTabOem}>
                  加油包
                  <div className={styles.rechargeCutDown}>
                    <Countdown
                      title={null}
                      value={curDeadLineTime}
                      format="HH:mm:ss:SSS"
                      onFinish={() => {
                        console.log('onFinishonFinishonFinish', new Date().getTime())
                        setTimeout(() => {
                          setCurDeadLineTime(new Date().setHours(23, 59, 59, 999))
                        }, 100)
                        // setCutdownShow(false)
                      }}
                    />
                    后结束
                  </div>
              </div>
            }
            <PayContent
              onCancel={onCancel}
              currentTab={currentTab}
              pageInfo={pageInfo}
              goodsList={goodsList}
              memberStatus={payUserInfo?.memberStatus}
              setTab={(tab: any) => setCurrentTab(tab)}
              payStatus={payStatus}
              setPayStatus={setPayStatus}
              updateUserInfo={(cb: any) => {
                getUser(cb)
              }}
              updateCouponList={(cb: any) => {
                getValidCoupon()
              }}
              showPromptTab={rest.showPrompt ? type : -1} // 微力不足-显示提示文案的tab
            />
          </div>
        </div>
      </div>
    </Modal>
  )
}

const openPayDialog = (
  params: {
    onClose?: Function // 取消回调
    pageInfo?: string //访问路径
    type?: number //tab类型 1套餐 2加油包
    needBindTel?:boolean//需要打开绑定手机号
    showPrompt?: boolean, // 微力不足-显示提示文案
    onSuccess?: Function // 支付成功回调
  } & ModalProps,
) => {
  const { onClose,needBindTel=true, ...rest } = params
  const dom = document.getElementById('payDialog')
  dom && dom.parentElement && dom.parentElement.removeChild(dom)
  const container = document.createElement('div')
  // const id = new Date().getTime() + 'exportDialog';
  const id = 'payDialog'
  container.setAttribute('id', id)
  container.classList.add(styles.payWrapper)
  document.body.appendChild(container)

  const root = ReactDOM.createRoot(container)
  const cancel = () => {
    root.unmount()
    container && container.parentElement && container.parentElement.removeChild(container)
  }
  window.addEventListener('popstate', function (event) {
    cancel()
  })

  return root.render(
    <PayDialog
      getContainer={() => container} // 注意这里我们改为返回container的函数，因为getContainer通常是一个函数
      // modalVisible={open}
      needBindTel={needBindTel}
      onCancel={userInfo => {
        cancel()
        onClose && onClose(userInfo)
      }}
      {...rest}
    />,
  )
}

// export default PayDialog;
export default openPayDialog
